import React from "react";

const delays = (index, step = 55) => ({ animationDelay: `${index * step}ms` });

export function LoadingState({ variant = "list", count = 6, label = "Cargando" }) {
  if (variant === "dashboard") {
    return (
      <div
        className="space-y-4 sm:space-y-6 p-3 sm:p-4 md:p-8"
        role="status"
        aria-busy="true"
        aria-label={label}
      >
        <div className="space-y-2">
          <div className="skeleton h-7 w-44 rounded-lg" />
          <div className="skeleton h-4 w-72 max-w-full rounded-md" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[0, 1, 2].map((i) => (
            <div key={i} className="skeleton h-[92px] rounded-xl" style={delays(i, 80)} />
          ))}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="skeleton h-72 rounded-xl" />
          <div className="skeleton h-72 rounded-xl" style={delays(1, 120)} />
        </div>
      </div>
    );
  }

  if (variant === "cards") {
    return (
      <div
        className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4"
        role="status"
        aria-busy="true"
        aria-label={label}
      >
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="rounded-xl border border-gray-100 bg-white p-4 space-y-3 shadow-sm">
            <div className="flex justify-between gap-3">
              <div className="skeleton h-5 w-16 rounded-md" style={delays(i % 8, 70)} />
              <div className="skeleton h-5 w-20 rounded-full" />
            </div>
            <div className="skeleton h-4 w-3/4 rounded-md" />
            <div className="skeleton h-3 w-1/2 rounded-md" />
            <div className="skeleton h-8 w-full rounded-lg" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === "compact") {
    return (
      <div className="px-3 py-3 space-y-2" role="status" aria-busy="true" aria-label={label}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton h-12 rounded-lg" style={delays(i)} />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2.5 py-1" role="status" aria-busy="true" aria-label={label}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton h-[3.25rem] rounded-xl" style={delays(i)} />
      ))}
    </div>
  );
}

export function SkeletonRows({ cols = 5, rows = 6 }) {
  return Array.from({ length: rows }).map((_, row) => (
    <tr key={row}>
      {Array.from({ length: cols }).map((_, col) => (
        <td key={col} className="px-4 py-3">
          <div
            className={`skeleton h-3.5 rounded-md ${col === 0 ? "w-36 max-w-full" : "w-14 ml-auto"}`}
            style={delays(row, 45)}
          />
        </td>
      ))}
    </tr>
  ));
}
